import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Dashboard.css';
import '../styles/main.css';
import { Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    username: 'Harsh',
    email: 'harsh.sharma@qcin.org',
    otp: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your submit logic here
    console.log('Password Changed:', formData);
  };

  const handleClear = () => {
    setFormData((prev) => ({
      ...prev,
      otp: '',
      newPassword: '',
      confirmPassword: '',
    }));
  };

  return (
    <>
     

      <div className="container mt-4 mb-4">
       <div className='row custombox'>
          <div className='rounded p-4 mb-4'>
            <div className="text-center customheader">
              <h5 className="mb-0">Change Password</h5>
            </div>

            <form onSubmit={handleSubmit}  >
              <div className="row">
                <div className="col-md-6">
                     <div className="row">
                <div className="col-md-6">
                  <label className='mb-3'>User Name</label>
                <input type="text" className="form-control" value={formData.username} disabled />

                  </div>
                      <div className="col-md-6 ">
                  <label className='mb-3'>Email ID</label>
                <input type="email" className="form-control" value={formData.email} disabled />
              
                      </div>
                       <div className="col-md-12  mt-3">
                         <label className='mb-3'>OTP <span className="text-danger">*</span></label>
                <input type="text" name="otp" className="form-control" value={formData.otp} onChange={handleChange} required />
             
                        
                      </div>
                       <div className="col-md-12 mt-5">
                         <Button variant="btn-primary" className="w-100 btn-fontweight">Click To Get OTP</Button>
          
                      </div>
                    
                </div>

                </div>

                <div className="col-md-6">
                         <div className="row">
                <div className="col-md-12">
                   <label className='mb-3'>New Password <span className="text-danger">*</span></label>
                <input type="password" name="newPassword" className="form-control" value={formData.newPassword} onChange={handleChange} required />
              
                  </div>
                  <div className="col-md-12  mt-3">
                     <label className='mb-3'>Confirm Password <span className="text-danger">*</span></label>
                <input type="password" name="confirmPassword" className="form-control" value={formData.confirmPassword} onChange={handleChange} required />
              
                  </div>
                  
                    <div className="col-md-12 mt-5">
                        <Button variant="secondary" type="button" className="px-4 me-3 btn-fontweight" onClick={handleClear}>Clear</Button>
              
                        <Button variant="btn-primary" type="submit" className="px-4  btn-fontweight">Change Password</Button>
              
                    </div>
                </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
